<template>
  <td v-if="score" class="score" :class="textcolor">
    {{ formatScore(score) }}
  </td>
  <td v-else class="score"></td>
</template>

<script>
import { formatScore } from '@/lib/utils'

export default {
  name: 'DiagnosticsModalTableCell',
  props: {
    score: {
      type: Number,
      required: false,
      default: null,
    },
    threshold: { type: Number, default: null },
  },
  computed: {
    textcolor() {
      if (this.threshold && this.score) {
        if (this.score > this.threshold) {
          return 'tier4color'
        }
        return 'tier3color'
      }
      return null
    },
  },
  methods: {
    formatScore,
  },
}
</script>

<style>
.score {
  font-size: 13px;
  text-align: right;
  color: var(--color-secondary);
  border-bottom: 1px dotted var(--color-tertiary);
  font-weight: 500;
  font-family: var(--number-font);
  font-feature-settings: 'tnum';
  font-variant-numeric: tabular-nums;
}

.tier3color {
  color: var(--color-secondary);
}
.tier4color {
  color: #ff8d64;
}
</style>
